import React from 'react'
import s from './ClosePopinButton.less'
import TagActionButton from './TagActionButton'
import SVGIcon from '../svg/SVGIcon'
import { TAG_BACK } from '../../store/analytics/analytics.actionTypes'
import { navigateBack } from '../../store/history/history.actions'
import { useAction } from '../utils/react-redux'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import { isGE, withOnlyGE } from '../Device'
import classnames from 'classnames'

const ClosePopinButton = ({ className }) => {
  const execNavigateBack = useAction(navigateBack)

  return (
    <TagActionButton type={TAG_BACK} deferClick onClick={() => execNavigateBack()}>
      <div className={classnames(s.closeButton, className)}>
        <SVGIcon icon={isGE() ? 'croix-android' : 'croix-iphone'} />
      </div>
    </TagActionButton>
  )
}

export const ClosePopinButtonGE = withOnlyGE(withEmptyFallbackErrorBoundary(ClosePopinButton))

export default withEmptyFallbackErrorBoundary(ClosePopinButton)
